import React, {Component} from 'react';
import './Explanation.css';

class Explanation extends Component {
	render() {
		return (
			<div className={`Explanation ${this.props.className || ''}`}>
				{this.props.children}
			</div>
		);
	}
}

export default Explanation;


// WEBPACK FOOTER //
// ./src/widgets/Explanation.js